import { createContext, useState, useContext } from "react";
import { MessageModal, ModalStateProps, ShowActionType as ShowModalActionType } from "./MessageModal";
import { ConfirmActionType, ConfirmModal } from "./ConfirmModal";

type NotificationContextprops = {
  message: (options: ShowModalActionType) => void;
  confirm: (options: ConfirmActionType) => void;
};
const NotificationContext = createContext({} as NotificationContextprops);

export const NotificationContextProvider = ({ children }) => {
  const [messageState, setMessageState] = useState({ open: false } as ModalStateProps);
  const [confirmState, setConfirmState] = useState({ open: false } as ModalStateProps);
  return (
    <NotificationContext.Provider
      value={{
        message: (options) => {
          setMessageState({ ...options, open: true });
        },
        confirm: (options) => {
          setConfirmState({ ...options, open: true });
        },
      }}
    >
      {children}
      <MessageModal {...messageState} handleState={(params) => setMessageState(params)} />
      <ConfirmModal {...confirmState} handleState={(params) => setConfirmState(params)} />
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => {
  return useContext(NotificationContext);
};
